import React, {Component} from 'react';
import {
    Button,
    FormControl
} from '@sketchpixy/rubix'
import {
    ADMIN_ROLE,
    APP_ADMIN_ROLE
} from '../utils'
import LoadingContainer from "./LoadingContainer";
import NotificationSystem from 'react-notification-system';


class AddNewUser extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: props.user,
            fetching: false
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
    }
    componentWillUnmount() {
    
    }
    _addNotification = (message, type, title) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title: title,
            level: type,
            position: 'br',
            autoDismiss: 5
        })
    
    }
    onChangeValue = (e, field) => {
        let {user} = this.state
        if (field === "first") {
            if (user.name) {
                user.name.first = e.target.value
            } else {
                user = {name : {first : e.target.value}}
            }
            
        } else if (field === "last") {
            if (user.name) {
                user.name.last = e.target.value
            } else {
                user = {name : {last : e.target.value}}
            }
        } else if (field === "email") {
            user.email = e.target.value
        } else if (field === "role") {
            user.role = e.target.value
        }
        this.setState({user})
    }
    validateEmail = (email) =>
    {
        var re = /^(([^<>()[\]\\.,;:\s@“]+(\.[^<>()[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email)
    }

    addNewUser = () => {
        let {user} = this.state
        const {history} = this.props
        if (user && user.name && user.email) {
            if (user.name.first && user.name.first.length>1 && user.name.last && user.name.last.length>1)
            {
                if (!user.role) {
                    user.role = ADMIN_ROLE
                }
                if (this.validateEmail(user.email)){
                    user.isAdmin = user.role === ADMIN_ROLE? true: false;
                    this.setState({fetching: true})
                    let token = localStorage.getItem('login_token');
                    let headers = {'Content-Type': 'application/json'};
                    headers["Authorization"] = `Bearer ${token}`
                    let url = process.env.API_URL+"/users/create"
                    let method = "POST";
                    if (user.id) {
                        url = process.env.API_URL+"/users/"+user.id
                        method = "PUT";
                    }
                
                    fetch(url, {method: method, body: JSON.stringify(user), headers} )
                    .then(response => response.json())
                    .then(data => {
                        this.setState({fetching: false})
                        if (data && data.id && data.email) {
                            history.push('/admin/profile');
                        } else {
                            this._addNotification(data.message, 'error', 'Error Message: ');
                        }
                    })
                    .catch(err => {
                        this.setState({fetching: false})
                        console.error(err)
                        });
                } else {
                    this._addNotification("Please enter a valid email", 'error', 'Error Message: ');
                }
            }
            else {
                this._addNotification("Name should be of at least two characters", 'error', 'Error Message: ');
            }           
        } else {
            this._addNotification("Please fill field values", 'error', 'Error Message: ');
        }
    }


    render() {
        const {
            onClose
          } = this.props
        const {user, fetching} = this.state
        console.log("ADD-NEW-USER", user)
        return (
            <div className="overlay-msg">
                {fetching && <LoadingContainer />}
                {<NotificationSystem ref='notificationSystem'/>}
                <div className="overlay-box">
                    <div className="row">                        
                        <div className="pull-right">
                        <span style={{width: '30px', height: '30px', borderRadius: '50%', background: '#fff', marginRight: 20, cursor: 'pointer'}} onClick={e => { onClose(e);}}>X</span>
                        </div>
                    </div><br />
                    <div className="row">
                            <div className='col-sm-4'>
                                <span>First Name:</span>
                            </div>
                            <div className='col-sm-7'>
                                <FormControl autoFocus
                                    type="text"
                                    className="text-field-modal"
                                    value={user && user.name && user.name.first ? user.name.first : ""}
                                    onChange={e => this.onChangeValue(e, "first")}
                                    >
                            </FormControl>
                            </div>
                    </div><br />
                    <div className="row">
                            <div className='col-sm-4'>
                                <span>Last Name:</span>
                            </div>
                            <div className='col-sm-7'>
                                <FormControl
                                    type="text"
                                    className="text-field-modal"
                                    value={user && user.name && user.name.last ? user.name.last : ""}
                                    onChange={e => this.onChangeValue(e, "last")}
                                    >
                            </FormControl>
                            </div>
                    </div><br />
                    <div className="row">
                            <div className='col-sm-4'>
                                <span>Role:</span>
                            </div>
                            <div className='col-sm-7'>
                                <FormControl
                                    componentClass="select"
                                    className="text-field-modal"   
                                    onChange={e => this.onChangeValue(e, "role")}
                                    value={user.role}                              
                                    >
                                        <option key="1" value={ADMIN_ROLE} label='Doctor' />
                                        <option key="2" value={APP_ADMIN_ROLE} label='Admin' />
                            </FormControl>
                            </div>
                    </div><br />
                    <div className="row">
                            <div className='col-sm-4'>
                                <span>Email:</span>
                            </div>
                            <div className='col-sm-7'>
                                <FormControl
                                    type="text"
                                    className="text-field-modal"
                                    value={user && user.email ? user.email : ""}
                                    onChange={e => this.onChangeValue(e, "email")}
                                    >
                            </FormControl>
                            </div>
                    </div><br />
                    <div className="row">
                        <div className='col-sm-11 pull-right' >
                        <Button
                            type='button'
                            name={"addNew"}
                            bsStyle='primary'
                            onClick={this.addNewUser}
                            className="list-btn"
                        >Save</Button>
                        </div>
                    </div>          
                </div>
            </div>
        );
    }
}

export default AddNewUser